const privateInfo = `<div>
        <div class="title__under">
            <p>隐私政策</p>
            <ins />
        </div>
        <div>
            <h4>引言</h4>
            <p>
            深圳市绽放芯知科技有限公司（以下简称“Bloom App”或“我们”）非常重视您的个人信息，并让您对个人信息拥有控制权，我们会使用强大的加密技术来保护您的隐私，同时制定严格的政策来管理所有数据。当您访问Bloom App时，或使用我们提供的服务前，您需要同意本政策中关于我们如何收集、使用、储存和分享您的相关信息的规定。如果您不同意本隐私政策中的任何内容，请立即停止使用或访问我们的产品和服务。
            本隐私权政策旨在协助您了解我们会收集哪些信息、为什么收集这些信息，以及您如何更新、管理、导出和删除自己的信息。若您对本政策有任何问题，请联系我们。 <br/>
            术语  <br/>
            Cookie：Cookie 是包含字符串的小文件，会在您访问网站时发送到您的计算机上。当您再次访问网站时，Cookie 使该网站可以识别您的浏览器。 <br/>Cookie 还能存储用户使用偏好及其他信息。您可以重置您的浏览器拒绝所有的 Cookie，或者在发送 Cookie 时提示。但如果没有 Cookie，某些网站功能或服务可能无法正常工作。
            <br/>应用数据缓存：应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。
            <br/>个人信息：用户向我们提供的、可用于识别用户的个人身份的信息，例如姓名、电子邮件地址、电话号码、银行卡号、身份证号码、住址、通讯记录等信息，或我们可以正当地通过链接找到此类信息的其他数据。
            <br/>IP地址：每台连接到互联网的计算机都指定了唯一的编号，称为互联网协议 (IP) 地址。由于这些编号通常都是根据国家/地区的区域指定的，因此 IP 地址通常可用于识别计算机连接至互联网时所在的国家/地区。
            <br/>
            <br/>
            <h4>一. 我们如何搜集和使用您的信息？</h4>
            1. 我们如何搜集您的信息？ <br/>
            我们提供服务时，可能会收集、储存和使用下列信息：
            <br/>1.1 您提供的信息
            <br/>1.1.1 您在注册账号或使用我们的服务时，向我们提供的相关个人信息，例如您的姓名、电子邮件地址、电话号码、住址、身份证号码等信息。如果您想充分使用我们提供的各种分享功能，可能还需要创建公开显示的个人资料，其中可能会包含您的姓名和照片。
            <br/>1.1.2 您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时上传、提交、存储、发送或接收的信息。
            <br/>1.2 您在使用服务过程中，我们获取的信息
            我们会收集您使用的服务以及使用方式的信息，如您何时在Bloom App观看了视频，何时访问了我们的广告服务，或何时查看了我们的广告和内容。此类信息包括：
            <br/>1.2.1 设备信息：我们会收集设备专用的信息，例如您的硬件型号、操作系统信息、移动设备版本、设备识别码、屏幕分表率等信息。
            <br/>1.2.2 日志信息
            <br/>o  A. 设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；
            <br/>0  B. 在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；
            <br/>1.2.3 IP地址
            <br/> A. 有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；
            <br/>o  B. 您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；
            <br/>o  C. 您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。
            <br/>1.2.4 设备中的视频、图片、游戏软件等
            为了给您提供全方位的服务体验，经过您的授权，我们的服务器会提取您设备中的视频、图片、软件名、版本号等，并通过加密上传到服务器进行比对，用于匹配与该视频、图片、软件相对应的显示功能。
            <br/>1.2.5 摄像头
            除本协议另有约定外，您设备上的摄像功能是保证您能多角度观看运动效果必备工具，如您禁用摄像功能，可能无法使用我们的部分产品或服务，或在使用过程中达不到最佳效果或使用受到限制。我们不会利用摄像头采集您的个人照片，除非经您授权或您自行上传、提交、发布，我们不会主动采集您设备中的图片、视频信息。
            <br/>1.2.6 位置信息
            您可以授权开启设备定位功能并使用我们基于位置提供的相关服务，当然，您也可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。
            <br/>1.2.7 通讯录和Bloom App
            如您想跟踪了解自己朋友们使用Bloom App的情况，可以申请使用Bloom App相关功能，我们将根据您的授权上传并保存您的应用列表，并以加密方式上传并保存用户通讯录中联系人手机号码，通过与服务器中信息匹配为您提供特色服务。
            <br/> 2. 我们如何使用您的信息
            <br/>我们可能将上述收集的信息用作以下用途：
            <br/>2.1 向您提供服务；
            <br/>2.2 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
            <br/>2.3 帮助我们设计新服务，改善我们现有服务；
            <br/>2.4 使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；
            <br/>2.5 向您提供与您更加相关的广告以替代普遍投放的广告；
            <br/>2.6 评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；
            <br/>2.7 执行软件验证、升级服务；
            <br/>2.8 应用户特殊要求而提供特定服务时，需要将信息提供给我们的关联公司、第三方或其他用户；
            <br/>2.9 其他有利于用户和Bloom App运营者利益且不违反任何强制性法律法规的情况。
            <br/>2.10 让您参与有关我们产品和服务的调查
            <br/>3. 我们承诺
            <br/>3.1 我们不会根据敏感类别（例如种族、宗教、性取向或健康状况）向您展示个性化广告；
            <br/>3.2 我们不会与广告主分享可用于识别您个人身份的信息，例如您的姓名或电子邮件地址（除非经您授权同意）；
            <br/>3.3 在任何时候、任何情况下都不会向任何第三方出售您的个人信息，我们只会在法律允许的范围内使用根据本协议获得的信息。我们会制定严格的政策保护您的个人信息，除非事先获得您的授权或本声明另有规定之外，不会将您的这些信息对外公开或向第三方提供。
            <br/>4. 为保证服务质量，我们可能会由关联公司或其他可信合作单位向您提供您所要求的服务或您可能感兴趣的内容。您同意我们向关联公司或合作单位分享该产品、服务所必须的个人信息。我们会要求关联公司及合作单位按照我们的说明、隐私政策以及任何其他适当的保密和安全措施来保证您的个人信息安全。除此之外，我们不会向任何第三方提供或分享您的信息。
            <br/>5.我们不会将您的个人信息转移或披露给任何非关联的第三方，除非：
            <br/>5.1 相关法律法规、法律程序、政府机关的强制性要求；
            <br/>5.2 为完成合并、分立、收购或资产转让而转移；
            <br/>5.3 事先获得您的授权；
            <br/>5.4 您使用共享功能；
            <br/>5.5 以学术研究或公共利益为目的；
            <br/>5.6 在法律法规和政策允许的范围内，为提升用户体验和提供个性化的推广服务；
            <br/>5.7 我们认为必要且不违反法律强制性规定的其他情形。
            <br/>6. 除非经过您的同意，否则我们不会向任何人提供您的敏感个人信息。
            <br/>
            <br/>
            <h4>二. 如何更新、变更、导出、删除您的信息</h4>
            1. 您在使用我们的产品和服务时，会被要求提供您真实的个人信息，您应当对您所提供信息的真实性、合法性、有效性及完整性负责，并及时更新和维护您的个人信息，以保证信息的真实、合法和有效。您可以随时管理您的个人信息，例如您的个人账号注册信息。
            <br/>2. 您可以自行从Bloom账号中删除您的内容或个人信息，或要求我们删除或修改信息，例如您想要删除个人帐户，可以与我们联络并提出您的要求。
            <br/>3. 在有些情况下，我们会出于法律目的或合法业务的需要将数据保留有限的一段时间。我们会尽力确保Bloom的服务能够保护信息免遭意外或恶意删除。因此，如果您删除了某些内容，我们可能会过一段时间才会从我们现用的和备用的系统中删除其副本。
            <br/>4. 您可以随时备份个人帐户名下的内容或将其用于非Bloom服务，您可以与我们联络并提出您的要求。
            <br/>
            <br/>
            <h4>三. 我们如何保护您的个人信息</h4>
            1. 所有Bloom产品都内置了强大的安全功能，并且我们制定了严格的信息管理政策，配备专业的技术团队，采取了一系列合理的预防措施，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失，其中包括：（1）使用加密技术来确保您的数据在传输过程中保持私密性；（2）提供多种安全功能来协助您保护自己的账号安全；（3）审查我们在收集、存储和处理信息方面的做法（包括实体安全措施），以防未经授权的人员访问我们的系统；（4）所有因提供服务而必须接触个人信息的Bloom员工、承包商和代理商等，都需要遵守合同中规定的严格保密义务，否则可将被处分或被解约。
            <br/>
            <br/>
            <h4>四. 我们如何处理未成年人提供的个人信息</h4>
             1. 我们非常重视未成年人信息的保护。我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。“未成年人”的定义应考虑适用的法律以及各国家和地区的文化惯例。
            <br/>
            <br/>
            <h4>五. 您分享的信息</h4>
             1. 我们会提供社交网络服务，您在使用这一类型服务时，您所上传或发布的信息（包括您公开的个人信息、您的通讯录、好友圈）、您对他人上传或发布的信息作出的回应，以及与这些信息有关的日志信息等，只要您不删除这些信息，它们会一直留存在公共领域，并被使用我们服务的其他用户分享、浏览。即使您删除这些信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存。
            <br/>2. 请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。您可以自行删除您上传、发布或分享的信息，如要求我们为您删除您的相关信息，请与我们联络并提出您的要求。
            <br/>
            <br/>
            <h4>六. 数据传输</h4>
             1. 我们维护着遍布世界各地的服务器，因此，我们处理您的信息时所用的服务器可能并不是位于您所在的国家或地区。数据保护法律因国家或地区而异，不同国家或地区的数据保护力度也是有强有弱。无论是在哪里处理您的信息，我们都会一律采用本政策中所述的保护措施。另外，我们还会遵守某些与数据传输有关的法律框架，例如“EU-US Privacy Shield Frameworks”和“Swiss-US Privacy Shield Frameworks”。
            <br/>2. 收到正式的书面投诉后，我们会与投诉方联系。我们会与相应的监管机构（包括当地的数据保护机构）合作，以解决任何与传输您的数据有关且无法由我们和您直接解决的投诉。
            <br/>
            <br/>
            <h4>七. 第三方服务提供商</h4>
             1. 为方便您的访问并丰富您的体验，可能会有第三方提供的产品或服务。您可以选择是否访问这类内容或链接，或是否使用该第三方的产品或服务。但我们对于第三方提供的产品或服务没有控制权。我们无法控制第三方掌握的您的任何个人信息。您在使用第三方产品或服务过程中的信息保护问题，不适用于本政策的管理。本政策也不适用于您自行选择提供给第三方的任何信息。请您查看该第三方的隐私保护政策。
             <br/>
            <h4>八.本政策的更新</h4>
             1. 我们可能会不定期修改、更新本隐私政策，有关隐私政策的更新，我们会在Bloom App中以通知公告等形式发布，您可以访问Bloom App查询最新版本的隐私政策。对于重大变更，我们会向您发出郑重通知（包括对于某些服务，我们会通过电子邮件发送通知，说明对隐私政策进行的更改）。
            <br/>
            <br/>
            <h4>九. 适用范围</h4>
             1. 我们的隐私政策适用于由北京卡路里科技有限公司及其关联公司提供的所有服务，包括Bloom App及www.webloom.cn上提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。
            <br/>2. 我们的隐私权政策不适用于第三方提供的产品和服务，例如在Bloom App及www.webloom.cn上由第三方提供的产品和服务，以及在我们的服务中链接到的其他网站，这些产品、服务或网站会有独立的隐私政策予以规范，请另行查阅相应的政策规定。
            <br/>3. 对于为我们的服务进行广告宣传，以及可能使用我们的cookie或其他日志信息来投放和使用广告的其他公司和组织，我们的隐私权政策并未涵盖其信息处理政策。
            </p>
            <br/>
        </div>
    </div>`

const profile = `<div>
        <div class="title__under">
            <p>用户协议</p>
            <ins />
        </div>
    <div>
        <h4>导言</h4>
        尊敬的用户：<br/>
        &nbsp;&nbsp;&nbsp;非常感谢您注册使用Bloom产品，为让您更好地使用Bloom提供的产品和服务，请您务必审慎阅读、充分理解《Bloom用户协议》（以下称“用户协议”或“本协议”）各条款内容，特别是免除或者限制责任的条款，并选择接受或不接受。
        <br/>除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用Bloom提供相关产品和服务。您的下载、安装、使用、登录等行为即视为您已阅读并同意本协议的约束。
        <br/>
        <br/>
       <h4> 1、接受条款</h4>
        Bloom根据以下服务条款为您提供服务。这些条款可由Bloom随时更新，且毋须另行通知。Bloom使用协议（以下简称“使用协议”）一旦发生变动，Bloom将在网页上公布修改内容。修改后的使用协议一旦在网页上公布即有效代替原来的使用协议。此外，当您使用Bloom特殊服务时，您和Bloom应遵守Bloom随时公布的与该服务相关的指引和规则。前述所有的指引和规则，均构成本使用协议的一部分。
        您在使用Bloom提供的各项服务之前，应仔细阅读本使用协议。如您不同意本使用协议及/或随时对其的修改，请您立即停止使用Bloom网所提供的全部服务；您一旦使用Bloom服务，即视为您已了解并完全同意本使用协议各项内容，包括Bloom对使用协议随时所做的任何修改，并成为Bloom用户（以下简称“用户”）。
        <br/>1.1 Bloom App及www.webloom.cn（以下统称“Bloom 产品”）是由深圳市绽放芯知科技有限公司及其关联公司（以下称“Bloom”或“我们”）提供的互联网产品和服务。
        <br/>1.2 本用户协议是用户（您）与Bloom之间关于使用Bloom提供的产品和服务所订立的协议，本协议条款的效力及于Bloom所提供的一切产品和服务，用户在享受Bloom任何单项服务时，应当受本协议的约束。
        <br/>1.3 本协议项下的产品和服务是指由Bloom发布的包括但不限于网络媒体、互联网增值、互动娱乐、电子商务和广告等的互联网产品和服务（形式包括但不限于在线视频、图片、软件、技术代码等）。
        <br/>1.4 本协议内容同时包括《隐私政策》及所有Bloom已经发布或未来可能发布的各类规则、公告或通知，且您在使用Bloom某一特定产品或服务时，可能会另有单独的协议、相关服务规则等，前述规则、公告、通知和协议一经发布即为本协议不可分割的组成部分，您同样应当遵守。如您不同意本协议的约定，您应立即停止注册/激活并停止使用Bloom的相关产品和服务。
        <br/>1.5 Bloom有权根据需要不时地修订本协议及/或各类规则（包括但不限于制定新的条款和修改既有条款），并以在线公告的方式进行变更公告，无须另行单独通知您。修订后的协议和规则一经公布，立即或在公告明确的特定时间自动生效。若您在前述公告修订后继续使用Bloom的产品或服务，即视为您已阅读、理解并接受经过修订的协议和规则。若您不同意修订，应当立即停止使用Bloom提供的产品和服务。
        <br/>1.6 除本协议明确规定外，对于利用Bloom开发/发布的产品和服务，Bloom有权在本协议的基础上通过单独的产品和服务协议（以下称“单项产品协议”）加以规范，用户须在使用有关产品或服务时另行了解与确认。单项产品协议与本协议有冲突的地方，以单项产品协议为准。如用户使用该产品或服务，即视为对相关单项产品协议的接受。
        <br/><br/>
        <h4>2、服务说明</h4>
         Bloom目前向用户提供如下服务：展示活动。除非本使用协议另有其它明示规定，增加或强化目前本服务的任何新功能，包括所推出的新产品，均受到本使用协议之规范。您了解并同意，本服务仅依其当前所呈现的状况提供，对于任何用户信息或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，Bloom均不承担任何责任。Bloom保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。
        <br/>
        <br/>
        <h4>3、遵守法律</h4>
        您同意遵守中华人民共和国相关法律法规的所有规定，并对以任何方式使用您的密码和您的账号使用本服务的任何行为及其结果承担全部责任。如您的行为违反国家法律和法规的任何规定，有可能构成犯罪的，将被追究刑事责任，并由您承担全部法律责任。
        同时如果Bloom有理由认为您的任何行为，包括但不限于您的任何言论和其它行为违反或可能违反国家法律和法规的任何规定，Bloom可在任何时候不经任何事先通知终止向您提供服务。
        <br/><br/>
        <h4>4、您的注册义务</h4>
        为了能使用本服务，您同意以下事项：依本服务注册提示请您填写正确的注册邮箱、密码和名号，并确保今后更新的登录邮箱、名号、头像等资料的有效性和合法性。若您提供任何违法、不道德或Bloom认为不适合在Bloom上展示的资料；或者Bloom有理由怀疑你的资料属于程序或恶意操作，Bloom有权暂停或终止您的账号，并拒绝您于现在和未来使用本服务之全部或任何部分。
        Bloom无须对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、正确性、完整性、适用性及/或是否为最新资料的责任。
        <br/><br/>
        <h4>5、用户账号、密码及安全</h4>
        完成本服务的注册程序并成功注册之后，您可使用您的手机号和密码，登录到您在Bloom的账号（下称“账号”）。保护您的账号安全，是您的责任。
        <br/>1)您的Bloom账号遭到未获授权的使用，或者发生其它任何安全问题时，您将立即通知Bloom；
        <br/>2)如果您未保管好自己的账号和密码，因此而产生的任何损失或损害，Bloom无法也不承担任何责任；
        <br/>3)每个用户都要对其账号中的所有行为和事件负全责。如果您未保管好自己的账号和密码而对您、Bloom或第三方造成的损害，您将负全部责任。
        <br/><br/>
        <h4>6、用户行为</h4>
        用户同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶
        <br/>1）发布或以其它方式传送含有下列内容之一的信息：
        <br/>·反对宪法所确定的基本原则的；
        <br/>·危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
        <br/>·损害国家荣誉和利益的；
        <br/>·煽动民族仇恨、民族歧视、破坏民族团结的；
        <br/>·破坏国家宗教政策，宣扬邪教和封建迷信的；
        <br/>·散布谣言，扰乱社会秩序，破坏社会稳定的；
        <br/>·散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
        <br/>·侮辱或者诽谤他人，侵害他人合法权利的；
        <br/>·含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；
        <br/>·含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；
        <br/>·含有Bloom认为不适合在Bloom展示的内容；
        <br/>2）以任何方式危害他人的合法权益；
        <br/>3）冒充其他任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；
        <br/>4）将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以发布、发送电子邮件或以其它方式传送；
        <br/>5）将侵害他人著作权、专利权、商标权、商业秘密、或其它专属权利（以下简称“专属权利”）之内容加以发布或以其它方式传送；
        <br/>6）将任何广告信函、促销资料、“垃圾邮件”、““滥发信件”、“连锁信件”、“直销”或其它任何形式的劝诱资料加以发布、发送或以其它方式传送；
        <br/>7）将设计目的在于干扰、破坏或限制任何计算机软件、硬件或通讯设备功能之计算机病毒（包括但不限于木马程序（trojanhorses）、蠕虫（worms）、定时炸弹、删除蝇（cancelbots）（以下简称“病毒”）或其它计算机代码、档案和程序之任何资料，加以发布、发送或以其它方式传送；
        <br/>8）干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；
        <br/>9）跟踪、人肉搜索或以其它方式骚扰他人；
        <br/>10）故意或非故意地违反任何适用的当地、国家法律，以及任何具有法律效力的规则；
        <br/>11）未经合法授权而截获、篡改、收集、储存或删除他人个人信息、站内邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的。
        <br/>您已认可Bloom未对用户的使用行为进行全面控制，您使用任何内容时，包括依赖前述内容之正确性、完整性或实用性时，您同意将自行加以判断并承担所有风险，而不依赖于Bloom。但Bloom依其自行之考虑，拒绝和删除可经由本服务提供之违反本条款的或其它引起Bloom反感的任何内容。\u2028您了解并同意，Bloom依据法律法规的要求，或基于诚信为了以下目的或在合理必要范围内，认定必须将内容加以保存或揭露时，得加以保存或揭露：
        <br/>a）遵守法律程序；
        <br/>b）执行本使用协议；
        <br/>c）回应任何第三人提出的权利主张；
        <br/>d）保护Bloom、其用户及公众之权利、财产或个人安全；
        <br/>e）其它Bloom认为有必要的情况。
        <br/><br/>
        <h4>7、用户隐私制度</h4>
        7.1 保护用户个人信息是Bloom的一项基本原则。Bloom将按照本协议及《隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息的保护规定与《隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。
        <br/>7.2 您在注册账号或使用Bloom产品和服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，可能无法使用Bloom的产品或服务，或在使用过程中受到限制。
        <br/>7.3 您可以随时浏览、修改自己提交的信息，但出于安全性和身份识别（如账号申诉服务）的考虑，您可能无法修改注册时提供的部分初始注册信息及其他验证信息。Bloom保留您修改个人信息的审核权。
        <br/>7.4 Bloom不会将您的个人信息转移或披露给任何非关联的第三方，除非：
        <br/>（1）相关法律法规或法院、政府机关要求；
        <br/>（2）为完成合并、分立、收购或资产转让而转移；
       <br/> （3）为提供您要求的服务所必须；
        <br/>（4）Bloom认定必要且不违反法律、法规强制性规定的其他情形。
        <br/>7.5 Bloom非常重视对未成年人信息的保护。若您是18周岁以下的未成年人，在使用Bloom的服务前，应事先取得您的法定监护人的同意。
        <br/><br/>
        <h4>8、在Bloom发布的公开信息</h4>
        1）在本使用协议中，“本服务公开使用区域”系指一般公众可以使用的区域；
        <br/>2）用户在Bloom上传或发布的内容，著作权均归用户本人所有。用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。为了促进知识的分享和传播，用户同意授予Bloom所有上述内容在全球范围内的免费、不可撤销的、永久的、可再许可或转让的非独家使用权许可，据该许可Bloom将有权以展示、推广及其他不为我法律所禁止的方式使用前述内容。
        <br/>3）第三方若出于非商业目的，将用户在Bloom上发表的内容转载在Bloom之外的地方，应当在作品的正文开头的显著位置注明原作者姓名（或原作者在Bloom上使用的账号名称），给出原始链接，注明「发表于Bloom」，并不得对作品进行修改演绎。若需要对作品进行修改，或用于商业目的，第三方应当联系用户获得单独授权，按照用户规定的方式使用该内容。
        <br/><br/>
        <h4>9、赔偿</h4>
        由于您通过本服务提供、发布或传送之内容、您与本服务连线、您违反本使用协议、或您侵害他人任何权利因而衍生或导致任何第三人提出任何索赔或请求，包括合理的律师费，您同意赔偿Bloom及其子公司、关联企业、高级职员、代理人、品牌共有人或其它合作伙伴及员工，并使其免受损害，并承担由此引发的全部法律责任。
        <br/><br/>
        <h4>10、关于使用及储存之一般措施</h4>
        您同意不对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。
        <br/><br/>
        <h4>11、关于使用及储存之一般措施</h4>
        您承认关于本服务的使用Bloom有权制订一般措施及限制，包含但不限于本服务将保留所发布内容或其它发布内容之最长期间，以及一定期间内您使用本服务之次数上限（及每次使用时间之上限）。通过本服务发布或传送之任何信息、通讯资料和其它内容，如被删除或未予储存，您同意Bloom毋须承担任何责任。您也同意，Bloom有权依其自行之考虑，不论通知与否，随时变更这些一般措施及限制。
        <br/><br/>
        <h4>12、服务之修改</h4>
        Bloom有权于任何时间暂时或永久修改或终止本服务（或其任何部分），且无论通知与否。您同意对于本服务所作的任何修改、暂停或终止，Bloom对您和任何第三人均无需承担任何责任。
        <br/><br/>
        <h4>13、终止服务</h4>
        您同意Bloom基于其自行之考虑，因任何理由，包含但不限于缺乏使用，或Bloom认为您已经违反本使用协议的文字及精神，终止您的账号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本使用协议任何规定提供之本服务，无需进行事先通知即可中断或终止，您承认并同意，Bloom可立即关闭或删除您的账号及您账号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的账号及相关信息和文件被关闭或删除，Bloom对您或任何第三人均不承担任何责任。
        <br/><br/>
        <h4>14、与广告商及其他第三方进行交易</h4>
        您通过本网站与广告商及其他第三方进行任何形式的通讯或商业往来，或参与促销活动，包含相关商品或服务之付款及交付，以及达成的其它任何相关条款、条件、保证或声明，完全为您与广告商及其他第三方之间之行为。您因前述任何交易或前述广告商及其他第三方而遭受的任何性质的损失或损害，Bloom对此不负任何法律责任。
        <br/><br/>
        <h4>15、Bloom之专属权利</h4>
        您了解并同意，本服务及本服务所使用之相关软件（以下简称“软件”）含有受到相关知识产权及其它法律保护之专有保密资料。您也了解并同意，经由本服务或广告商向您呈现之赞助广告或信息所包含之内容，亦受到著作权、商标权、服务商标、专利权或其它专属权利之法律保护。未经Bloom或广告商明示授权，您不得修改、出租、出借、出售、散布本服务或软件之任何部份或全部，或据以制作衍生著作，或使用擅自修改后的软件，包括但不限于为了未经授权而使用本服务之目的。Bloom仅授予您个人、不可移转及非专属之使用权，使您得于单机计算机使用其软件之目的码，但您不得（并不得允许任何第三人）复制、修改、创作衍生著作、进行还原工程、反向组译，或以其它方式发现原始码，或出售、转让、再授权或提供软件设定担保，或以其它方式移转软件之任何权利。您同意将通过由Bloom所提供的界面而非任何其它途径使用本服务。
        <br/><br/>
        <h4>16、担保与保证</h4>
        您明确了解并同意∶
        <br/>1）本使用协议的任何规定不会免除Bloom对造成您人身伤害的、或因故意或重大过失造成您财产损失的任何责任；
        <br/>2）您使用本服务之风险由您个人负担。本服务系依“现状”及“现有”基础提供。Bloom对本服务不提供任何明示或默示的担保或保证，包含但不限于商业适售性、特定目的之适用性及未侵害他人权利等担保或保证；
        <br/>3）Bloom不保证以下事项∶\u2028·本服务将符合您的要求；\u2028·本服务将不受干扰、及时提供、安全可靠或不会出错；\u2028·使用本服务取得之结果正确可靠；\u2028·您经由本服务购买或取得之任何产品、服务、资讯或其它信息将符合您的期望；
        <br/>4）是否使用本服务下载或取得任何资料应由您自行考虑且自负风险，因任何资料之下载而导致的您电脑系统之任何损坏或数据流失等后果，由您自行承担；
        <br/>5）您自Bloom或经由本服务取得的任何建议或信息，无论是书面或口头形式，除非本使用协议有明确规定，将不构成本使用协议以外之任何保证。
        <br/><br/>
        <h4>17、责任限制</h4>
        您明确了解并同意，基于以下原因而造成的，包括但不限于利润、信誉、应用、数据损失或其它无形损失，Bloom不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任：
        <br/>1）本服务之使用或无法使用；
        <br/>2）为替换从或通过本服务购买或取得之任何商品、数据、信息、服务，收到的讯息，或缔结之交易而发生的成本；
        <br/>3）您的传输或数据遭到未获授权的存取或变造；
        <br/>4）任何第三方在本服务中所作之声明或行为；
       <br/> 5）与本服务相关的其它事宜，但本使用协议有明确规定的除外；
        <br/>6）第三方以任何方式发布或投递欺诈性信息，或诱导用户受到经济损失，Bloom不承担任何责任。
        <br/><br/>
        <h4>18、Bloom商标信息</h4>
        Bloom官网、Bloom应用软件以及其它Bloom注册商标、标志及产品、服务名称，均为Bloom之商标（以下简称“Bloom标记”）。未经Bloom事先书面同意，您同意不将Bloom标记以任何方式展示或使用或作其它处理，或表示您有权展示、使用或另行处理Bloom标记。
        <br/><br/>
        <h4>19、用户专属权利</h4>
        Bloom尊重他人知识产权，呼吁用户也要同样尊重知识产权。
        <br/>Bloom之服务与资料是基于“现状”提供，而且Bloom明确地表示拒绝对于“服务”、“资料”或“产品”给予任何明示或暗示之保证，包括但不限于，得为商业使用或适合于特定目的之保证。Bloom对于因“服务”、“资料”或“产品”所生之任何直接、间接、附带的或因此而导致之衍生性损失概不负责。
        如果您对他人的知识产权造成了侵害，Bloom将依国家法律法规的规定，或在适当的情形下，将依其服务条款或其相关规范性规定，删除特定内容或以至终止您对账号的使用。
        Bloom尊重他人的任何权利（包括知识产权），同时也要求我们的使用者也尊重他人之权利。Bloom在适当情况下，得自行决定终止侵害或违反他人权利之使用者的账号。
        若您认为您的作品的著作权遭到侵害或您的知识产权被侵犯，根据《信息网络传播权保护条例》的规定，您需及时向Bloom联系并提供详实的举证材料。或请到中华人民共和国国家版权局下载《要求删除或断开链接侵权网络内容的通知》（下称“删除通知”）的示范格式，如果您不明白“删除通知”的内容，请登录中华人民共和国国家版权局查看《要求删除或断开链接侵权网络内容的通知》填写说明。
        <br/>
        <br/>
        <h4>20、一般条款</h4>
        您明确了解并同意，基于以下原因而造成的，包括但不限于利润、信誉、应用、数据损失或其它无形损失，Bloom不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任：
        1）本使用协议、社区指导原则和免责声明构成您与Bloom之全部协议，并规范您对于本服务之使用行为。在您使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件；
        2）本使用协议及您与Bloom之关系，均受到中华人民共和国法律管辖。您与Bloom就本服务、本使用协议或其它有关事项发生的争议，应首先友好协商解决，协商不成时应提请中国国际经济贸易仲裁委员会仲裁，仲裁裁决是终局性的，对双方均有约束力；
        3）Bloom未行使或执行本使用协议任何权利或规定，不构成对前述权利或权利之放弃；
        4）倘本使用协议之任何规定因与中华人民共和国法律抵触而无效，您依然同意应依照法律，努力使该规定所反映之当事人意向具备效力，且本使用协议其它规定仍应具有完整的效力及效果；
        5）本使用协议之标题仅供方便而设，不具任何法律或契约效果；
        6）Bloom对本使用协议享有最终解释权。
        <br/>
        </div>
    </div>`

const newProfile = `<div class="h2">Bloom 平台用户协议</div>
    <p class="text">引言</p>
    <p>尊敬的用户：<o:p></o:p></p>
      <p>
        非常感谢您注册成为Bloom平台（定义见下文）用户，为让您更好地使用Bloom平台提供的产品和服务，请您务必审慎阅读、充分理解《Bloom平台用户协议》（以下称“用户协议”或“本协议”）各条款内容，<b
          ><u>特别是免除或者限制责任</u></b
        ><b><u>、争议解决和法律适用</u></b
        ><b><u>的条款，并选择接受或不接受</u></b
        ><b
          ><u
            >，其中免除或限制责任的条款将以加粗字体及下划线显示，您应重点阅读</u
          ></b
        ><b>。</b>
        <o:p></o:p>
      </p>
      <p>
        除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用Bloom平台提供相关产品和服务。当您按照注册页面提示填写信息、阅读并点击同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与我们达成一致，成为Bloom平台的“用户”（以下简称“用户”）。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。<o:p
        ></o:p>
      </p>
      <p>
        <b>1、接受条款</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>Bloom根据以下服务条款为您提供服务。<o:p></o:p></p>
      <p>
        1.1 Bloom App、<a href="http://www.webloom.cn"><u>www.webloom.cn</u></a
        >网页端等客户端（以下统称“Bloom平台”）是由深圳市绽放芯知科技有限公司及其关联公司（以下称“Bloom”或“我们”）提供的互联网产品和服务。<o:p
        ></o:p>
      </p>
      <p>
        1.2
        本协议是用户（您）与Bloom之间关于使用Bloom提供的产品和服务所订立的协议，本协议条款的效力及于Bloom所提供的一切产品和服务（含第三方服务商所提供的产品和服务），用户在享受Bloom任何单项服务时，应当受本协议的约束。<o:p
        ></o:p>
      </p>
      <p>
        1.3
        本协议项下的产品和服务是指由Bloom及Bloom合作的第三方服务商于Bloom平台发布的包括但不限于网络媒体、互联网增值、互动娱乐、电子商务和广告等的互联网产品和服务（形式包括但不限于在线视频、图片、软件、技术代码等）。<o:p
        ></o:p>
      </p>
      <p>
        1.4
        本协议内容同时包括《Bloom平台隐私政策》《Bloom平台儿童用户协议》《Bloom平台儿童个人信息隐私权政策》及所有Bloom已经发布或未来可能发布的各类规则、公告或通知，且您在使用Bloom某一特定产品或服务时，可能会另有单独的协议、相关服务规则等，前述规则、公告、通知和协议一经发布即为本协议不可分割的组成部分，您同样应当遵守。如您不同意本协议的约定，您应立即停止注册/激活并停止使用Bloom的相关产品和服务。<o:p
        ></o:p>
      </p>
      <p>
        1.5
        Bloom有权根据需要不时地修订本协议及/或各类规则（包括但不限于制定新的条款和修改既有条款），并以在线公告的方式进行变更公告，无须另行单独通知您。修订后的协议和规则一经公布，立即或在公告明确的特定时间自动生效。若您在前述公告修订后继续使用Bloom的产品或服务，即视为您已阅读、理解并接受经过修订的协议和规则。若您不同意修订，应当立即停止使用Bloom提供的产品和服务。<o:p
        ></o:p>
      </p>
      <p>
        <b>2、服务说明</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        Bloom目前向用户提供如下服务：展示Bloom及Bloom平台第三方服务商所提供的各项素质教育及社会化学习相关的项目、活动及信息社区平台服务。除非本协议另有其它明示规定，增加或强化目前本服务的任何新功能，包括所推出的新产品，均受到本协议之规范。您了解并同意，本服务仅依其当前所呈现的状况提供，对于任何用户信息或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，Bloom均不承担任何责任。Bloom保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。<o:p
        ></o:p>
      </p>
      <p>
        <b>3、遵守法律</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        您同意遵守中华人民共和国相关法律法规的所有规定，并对以任何方式使用您的密码和您的帐号使用本服务的任何行为及其结果承担全部责任。如您的行为违反国家法律和法规的任何规定，有可能构成犯罪的，将被追究刑事责任，并由您承担全部法律责任。同时如果Bloom有理由认为您的任何行为，包括但不限于您的任何言论和其它行为违反或可能违反国家法律和法规的任何规定，Bloom可在任何时候不经任何事先通知终止向您提供服务。<o:p
        ></o:p>
      </p>
      <p>
        <b>4、您的注册义务</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        为了能使用本服务，您同意以下事项：依注册提示请您填写正确的手机号/邮箱、密码，并确保今后更新的登录手机号、邮箱、昵称、头像、简介等资料的有效性和合法性。若您提供任何违法、不道德或Bloom认为不适合在Bloom上展示的资料；或者Bloom有理由怀疑你的资料属于程序或恶意操作，Bloom有权暂停或终止您的帐号，并拒绝您于现在和未来使用本服务之全部或任何部分。
        Bloom无须对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、正确性、完整性、适用性及/或是否为最新资料的责任。<o:p
        ></o:p>
      </p>
      <p>
        <b>5、用户帐号、密码及安全</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        完成本服务的注册程序并成功注册之后，您可使用您的手机号和密码，登录到您在Bloom的帐号（下称“帐号”）。保护您的帐号安全，是您的责任。<o:p
        ></o:p>
      </p>
      <p>
        1)您的Bloom帐号遭到未获授权的使用，或者发生其它任何安全问题时，您将立即通知Bloom；<o:p
        ></o:p>
      </p>
      <p>
        2)如果您未保管好自己的帐号和密码，因此而产生的任何损失或损害，Bloom无法也不承担任何责任；<o:p
        ></o:p>
      </p>
      <p>
        3)每个用户都要对其帐号中的所有行为和事件负全责。如果您未保管好自己的帐号和密码而对您、Bloom或第三方造成的损害，您将负全部责任。<o:p
        ></o:p>
      </p>
      <p>
        <b>6、用户行为</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        用户同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶<o:p
        ></o:p>
      </p>
      <p>1）发布或以其它方式传送含有下列内容之一的信息：<o:p></o:p></p>
      <p>· 反对宪法所确定的基本原则的；<o:p></o:p></p>
      <p>
        · 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<o:p></o:p>
      </p>
      <p>· 损害国家荣誉和利益的；<o:p></o:p></p>
      <p>· 煽动民族仇恨、民族歧视、破坏民族团结的；<o:p></o:p></p>
      <p>· 破坏国家宗教政策，宣扬邪教和封建迷信的；<o:p></o:p></p>
      <p>· 散布谣言，扰乱社会秩序，破坏社会稳定的；<o:p></o:p></p>
      <p>· 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<o:p></o:p></p>
      <p>· 侮辱或者诽谤他人，侵害他人合法权利的；<o:p></o:p></p>
      <p>
        ·
        含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；<o:p
        ></o:p>
      </p>
      <p>
        · 含有中国法律、法规、规章、规范性文件等所限制或禁止的其它内容的；<o:p
        ></o:p>
      </p>
      <p>· 含有Bloom认为不适合在Bloom展示的内容；<o:p></o:p></p>
      <p>2）以任何方式危害他人的合法权益；<o:p></o:p></p>
      <p>
        3）冒充其他任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；<o:p
        ></o:p>
      </p>
      <p>
        4）将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以发布、发送电子邮件或以其它方式传送；<o:p
        ></o:p>
      </p>
      <p>
        5）将侵害他人著作权、专利权、商标权、商业秘密、或其它专属权利（以下简称“专属权利”）之内容加以发布或以其它方式传送；<o:p
        ></o:p>
      </p>
      <p>
        6）将任何广告信函、促销资料、“垃圾邮件”、“滥发信件”、“连锁信件”、“直销”或其它任何形式的劝诱资料加以发布、发送或以其它方式传送；<o:p
        ></o:p>
      </p>
      <p>
        7）将设计目的在于干扰、破坏或限制任何计算机软件、硬件或通讯设备功能之计算机病毒（包括但不限于木马程序（trojanhorses）、蠕虫（worms）、定时炸弹、删除蝇（cancelbots）（以下简称“病毒”）或其它计算机代码、档案和程序之任何资料，加以发布、发送或以其它方式传送；<o:p
        ></o:p>
      </p>
      <p>
        8）干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；<o:p
        ></o:p>
      </p>
      <p>9）跟踪、人肉搜索或以其它方式骚扰他人；<o:p></o:p></p>
      <p>
        10）故意或非故意地违反任何适用的当地、国家法律，以及任何具有法律效力的规则；<o:p
        ></o:p>
      </p>
      <p>
        11）未经合法授权而截获、篡改、收集、储存或删除他人个人信息、站内邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的。<o:p
        ></o:p>
      </p>
      <p>
        您已认可Bloom未对用户的使用行为进行全面控制，您使用任何内容时，包括依赖前述内容之正确性、完整性或实用性时，您同意将自行加以判断并承担所有风险，而不依赖于Bloom。但Bloom依其自行之考虑，拒绝和删除可经由本服务提供之违反本条款的或其它引起Bloom反感的任何内容。您了解并同意，Bloom依据法律法规的要求，或基于诚信为了以下目的或在合理必要范围内，认定必须将内容加以保存或揭露时，得加以保存或揭露：<o:p
        ></o:p>
      </p>
      <p>a）遵守法律程序；<o:p></o:p></p>
      <p>b）执行本协议；<o:p></o:p></p>
      <p>c）回应任何第三人提出的权利主张；<o:p></o:p></p>
      <p>d）保护Bloom、其用户及公众之权利、财产或个人安全；<o:p></o:p></p>
      <p>e）其它Bloom认为有必要的情况。</p>
      <p>
        <b>7、</b><b>未成年人使用条款</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        <b><u>若您是未满</u></b
        ><b
          ><u
            >18周岁的未成年人，您应在您的监护人监护、指导下并获得监护人同意的情况下，认真阅读并同意本协议后，方可使用Bloom</u
          ></b
        ><b><u>平台及相关服务。若您是未满</u></b
        ><b><u>14</u></b
        ><b
          ><u
            >周岁的儿童，在您使用我们的服务前，您和您的父母或其他监护人应仔细阅读我们专门制定的《</u
          ></b
        ><b><u>Bloom</u></b
        ><b><u>平台儿童用户协议》，在确保已取得父母或其他监护人对《</u></b
        ><b><u>Bloom</u></b
        ><b
          ><u
            >平台儿童用户协议》的同意后，您才可在父母或其他监护人的指导下使用我们的服务，确保您在使用我们的服务和进行交易时的安全。</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b
          ><u
            >未成年人用户及其监护人理解并确认，如您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此而可能导致的全部法律责任。</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b>7</b><b>.1未成年人用户特别提示</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        未成年人使用Bloom平台及相关服务应该<b
          ><u
            >在其监护人的监督指导下，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好上网习惯</u
          ></b
        ><b>。</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        <b>7</b><b>.2</b>青少年用户必须遵守《全国青少年网络文明公约》：<o:p
        ></o:p>
      </p>
      <p>(1) 要善于网上学习，不浏览不良信息；<o:p></o:p></p>
      <p>(2) 要诚实友好交流，不侮辱欺诈他人；<o:p></o:p></p>
      <p>(3) 要增强自护意识，不随意约会网友；<o:p></o:p></p>
      <p>(4) 要维护网络安全，不破坏网络秩序；<o:p></o:p></p>
      <p>(5) 要有益身心健康，不沉溺虚拟时空。<o:p></o:p></p>
      <p>
        为更好地保护未成年人隐私权益，<b
          ><u
            >我们特别提醒您慎重发布包含未成年人素材的内容，一经发布，即视为您已获得权利人同意在</u
          ></b
        ><b><u>Bloom</u></b
        ><b
          ><u
            >平台及相关服务展示未成年人的肖像、声音等信息，且允许公司依据本协议使用、处理该等与未成年人相关的内容</u
          ></b
        ><b>。</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        <b>7</b><b>.3</b><b>监护人特别提示</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        如您的被监护人使用Bloom平台及相关服务的，您作为监护人应指导并监督被监护人的注册和使用行为，<b
          ><u>如您的被监护人申请注册</u></b
        ><b><u>Bloom</u></b
        ><b><u>平台账户，我们将有权认为其已取得您的同意</u></b
        ><b>。</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        您的被监护人在使用Bloom平台及相关服务时可能进行购买商品及/或服务等行为。<b
          ><u
            >您作为监护人，请保管好您的支付设备、支付账户及支付密码等，以避免被监护人在未取得您同意的情况下通过您的</u
          ></b
        ><b><u>Bloom</u></b
        ><b><u>平台账户进行购买商品及</u></b
        ><b><u>/或服务等行为</u></b
        ><b>。</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        <b>8、</b><b>用户隐私制度</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        8.1
        保护用户个人信息是Bloom的一项基本原则。Bloom将按照本协议及《Bloom平台隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息的保护规定与《Bloom平台隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《Bloom平台隐私政策》的内容为准。<o:p
        ></o:p>
      </p>
      <p>
        8.2
        您在注册帐号或使用Bloom产品和服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，可能无法使用Bloom的产品或服务，或在使用过程中受到限制。<o:p
        ></o:p>
      </p>
      <p>
        8.3
        您可以随时浏览、修改自己提交的信息，但出于安全性和身份识别（如帐号申诉服务）的考虑，您可能无法修改注册时提供的部分初始注册信息及其他验证信息。Bloom保留您修改个人信息的审核权。<o:p
        ></o:p>
      </p>
      <p>
        8.4 Bloom不会将您的个人信息转移或披露给任何非关联的第三方，除非：<o:p
        ></o:p>
      </p>
      <p>（1）相关法律法规或法院、政府机关要求；<o:p></o:p></p>
      <p>（2）为完成合并、分立、收购或资产转让而转移；<o:p></o:p></p>
      <p>（3）为提供您要求的服务所必须；<o:p></o:p></p>
      <p>
        （4）Bloom认定必要且不违反法律、法规强制性规定的其他情形。<o:p></o:p>
      </p>
      <p>
        8.5
        Bloom非常重视对未成年人信息的保护。若您是18周岁以下的未成年人，在使用Bloom的服务前，应事先取得您的法定监护人的同意。若您是14周岁以下儿童的，在您使用我们的服务前，您和您的父母或其他监护人应仔细阅读我们专门制定的《Bloom平台儿童个人信息隐私权政策》，在确保已取得父母或其他监护人对《Bloom平台儿童个人信息隐私权政策》的同意后，您才可在父母或其他监护人的指导下使用我们的服务，确保您在使用我们的服务和进行交易时的安全。若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务的。如您对您所监护的儿童的个人信息有疑问，请通过Bloom平台客服与我们联系。
      </p>
      <p>
        <b>9、在Bloom发布的公开信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        1）在本协议中，“本服务公开使用区域”系指一般公众可以使用的区域；<o:p
        ></o:p>
      </p>
      <p>
        2）用户在Bloom上传或发布的内容，著作权均归用户本人所有。用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。为了促进知识的分享和传播，用户同意授予Bloom所有上述内容在全球范围内的免费、不可撤销的、永久的、可再许可或转让的非独家使用权许可，据该许可Bloom将有权以展示、推广及其他不为我法律所禁止的方式使用前述内容。<o:p
        ></o:p>
      </p>
      <p>
        3）第三方若出于非商业目的，将用户在Bloom上发表的内容转载在Bloom之外的地方，应当在作品的正文开头的显著位置注明原作者姓名（或原作者在Bloom上使用的帐号名称），给出原始链接，注明「发表于Bloom」，并不得对作品进行修改演绎。若需要对作品进行修改，或用于商业目的，第三方应当联系用户获得单独授权，按照用户规定的方式使用该内容。<o:p
        ></o:p>
      </p>
      <p>
        <b>10、赔偿</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        由于您通过本服务提供、发布或传送之内容、您违反本协议、或您侵害他人任何权利因而衍生或导致任何第三人提出任何索赔或请求，包括合理的律师费，您同意赔偿Bloom及其子公司、关联企业、高级职员、代理人或其它合作伙伴及员工，并使其免受损害，并承担由此引发的全部法律责任。<o:p
        ></o:p>
      </p>
      <p>
        <b>11、关于使用及储存之一般措施</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        您同意不对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。<o:p
        ></o:p>
      </p>
      <p>
        <b>12、关于使用及储存之一般措施</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        您承认关于本服务的使用Bloom有权制订一般措施及限制，包含但不限于本服务将保留所发布内容或其它发布内容之最长期间，以及一定期间内您使用本服务之次数上限（及每次使用时间之上限）。通过本服务发布或传送之任何信息、通讯资料和其它内容，如被删除或未予储存，您同意Bloom毋须承担任何责任。您也同意，Bloom有权依其自行之考虑，不论通知与否，随时变更这些一般措施及限制。<o:p
        ></o:p>
      </p>
      <p>
        <b>13、服务之修改</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        Bloom有权于任何时间暂时或永久修改或终止本服务（或其任何部分），且无论通知与否。您同意对于本服务所作的任何修改、暂停或终止，Bloom对您和任何第三人均无需承担任何责任。<o:p
        ></o:p>
      </p>
      <p>
        <b>14、终止服务</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        您同意Bloom基于其自行之考虑，因任何理由，包含但不限于缺乏使用，或Bloom认为您已经违反本协议的文字及精神，终止您的帐号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本协议任何规定提供之本服务，无需进行事先通知即可中断或终止，您承认并同意，Bloom可立即关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的帐号及相关信息和文件被关闭或删除，Bloom对您或任何第三人均不承担任何责任。<o:p
        ></o:p>
      </p>
      <p>
        <b>15、与</b><b>Bloom平台第三方服务商及</b><b>广告商</b><b>等</b
        ><b>其他第三方进行交易</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        您通过本网站与Bloom平台第三方服务商及广告商等其他第三方达成交易、进行任何形式的通讯或商业往来，或参与促销活动，包含相关商品或服务之付款及交付，以及达成的其它任何相关条款、条件、保证或声明，完全为您与Bloom平台第三方服务商及广告商等其他第三方之间之行为。您因前述任何交易或前述Bloom平台第三方服务商及广告商等其他第三方而遭受的任何性质的损失或损害，Bloom对此不负任何法律责任。<o:p
        ></o:p>
      </p>
      <p>16、Bloom之专属权利<o:p></o:p></p>
      <p>
        您了解并同意，我们为您提供的服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。Bloom仅授予您个人、不可移转及非专属之使用权，使您得于单机计算机使用其软件之目的码，但您不得（并不得允许任何第三人）复制、修改、创作衍生著作、进行还原工程、反向组译，或以其它方式发现原始码，或出售、转让、再授权或提供软件设定担保，或以其它方式移转软件之任何权利。您同意将通过由Bloom所提供的界面而非任何其它途径使用本服务。<o:p
        ></o:p>
      </p>
      <p>
        <b><u>对于您发表到</u></b
        ><b><u>Bloom</u></b
        ><b><u>上的任何内容，您同意</u></b
        ><b><u>Bloom</u></b
        ><b
          ><u
            >在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和</u
          ></b
        ><b
          ><u
            >/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中</u
          ></b
        ><b><u>，同时，您许可</u></b
        ><b><u>Bloom</u></b
        ><b
          ><u
            >有权利就任何主体侵权而单独采取法律行动（包括但不限于诉讼、举报、律师函等形式）</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>
        <b>17、担保与保证</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>您明确了解并同意∶<o:p></o:p></p>
      <p>
        1）本协议的任何规定不会免除Bloom对造成您人身伤害的、或因故意或重大过失造成您财产损失的任何责任；<o:p
        ></o:p>
      </p>
      <p>
        2）您使用本服务之风险由您个人负担。本服务系依“现状”及“现有”基础提供。Bloom对本服务不提供任何明示或默示的担保或保证，包含但不限于商业适售性、特定目的之适用性及未侵害他人权利等担保或保证；<o:p
        ></o:p>
      </p>
      <p>3）Bloom不保证以下事项∶<o:p></o:p></p>
      <p>· 本服务将符合您的要求；<o:p></o:p></p>
      <p>· 本服务将不受干扰、及时提供、安全可靠或不会出错；<o:p></o:p></p>
      <p>· 使用本服务取得之结果正确可靠；<o:p></o:p></p>
      <p>
        ·
        您经由本服务购买或取得之任何产品、服务、资讯或其它信息将符合您的期望；<o:p
        ></o:p>
      </p>
      <p>
        4）是否使用本服务下载或取得任何资料应由您自行考虑且自负风险，因任何资料之下载而导致的您电脑系统之任何损坏或数据流失等后果，由您自行承担；<o:p
        ></o:p>
      </p>
      <p>
        5）您自Bloom或经由本服务取得的任何建议或信息，无论是书面或口头形式，除非本协议有明确规定，将不构成本协议以外之任何保证。<o:p
        ></o:p>
      </p>
      <p>
        <b>18、责任限制</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        您明确了解并同意，基于以下原因而造成的，包括但不限于利润、信誉、应用、数据损失或其它无形损失，Bloom不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任：<o:p
        ></o:p>
      </p>
      <p>1）本服务之使用或无法使用；<o:p></o:p></p>
      <p>
        2）为替换从或通过本服务购买或取得之任何商品、数据、信息、服务，收到的讯息，或缔结之交易而发生的成本；<o:p
        ></o:p>
      </p>
      <p>3）您的传输或数据遭到未获授权的存取或变造；<o:p></o:p></p>
      <p>4）任何第三方在本服务中所作之声明或行为；<o:p></o:p></p>
      <p>5）与本服务相关的其它事宜，但本协议有明确规定的除外；<o:p></o:p></p>
      <p>
        6）第三方以任何方式发布或投递欺诈性信息，或诱导用户受到经济损失，Bloom不承担任何责任。<o:p
        ></o:p>
      </p>
      <p>
        <b>19、Bloom商标信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        Bloom以及Bloom平台内相关项目商标、标志及产品、服务名称，均为Bloom自有或经合法授权使用之商标（以下简称“Bloom商标”）。未经Bloom事先书面同意，您同意不将Bloom商标以任何方式展示或使用或作其它处理，或表示您有权展示、使用或另行处理Bloom商标。<o:p
        ></o:p>
      </p>
      <p>
        <b>20、用户专属权利</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>Bloom尊重他人知识产权，呼吁用户也要同样尊重知识产权。<o:p></o:p></p>
      <p>
        Bloom之服务与资料是基于“现状”提供，而且Bloom明确地表示拒绝对于“服务”、“资料”或“产品”给予任何明示或暗示之保证，包括但不限于，得为商业使用或适合于特定目的之保证。Bloom对于因“服务”、“资料”或“产品”所生之任何直接、间接、附带的或因此而导致之衍生性损失概不负责。
        如果您对他人的知识产权造成了侵害，Bloom将依国家法律法规的规定，或在适当的情形下，将依其服务条款或其相关规范性规定，删除特定内容或以至终止您对帐号的使用。
        Bloom尊重他人的任何权利（包括知识产权），同时也要求我们的使用者也尊重他人之权利。您知悉并同意：（1）如您存在侵犯他人知识产权的违规行为，我们有权采取删除、屏蔽、断开链接、终止交易和服务等必要措施；（2）如权利人认为其知识产权受到侵害而通知我们采取删除、屏蔽、断开链接、终止交易和服务等必要措施的，我们有权采取必要措施，并将该通知转送给您。您接到转送的通知后，可以向我们提交不存在侵权行为的声明。声明应当包括不存在侵权行为的初步证据。我们接到您的声明后，会将该声明转送发出通知的权利人，并告知其可以向有关主管部门投诉或者向人民法院起诉。我们在转送声明到达权利人后十五日内，未收到权利人已经投诉或者起诉通知的，会及时终止所采取的措施。<o:p
        ></o:p>
      </p>
      <p>
        <b>21、一般条款</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        您明确了解并同意，基于以下原因而造成的，包括但不限于利润、信誉、应用、数据损失或其它无形损失，Bloom不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任：<o:p
        ></o:p>
      </p>
      <p>
        1）本协议、Bloom平台规则等相关声明、通知构成您与Bloom之全部协议，并规范您对于本服务之使用行为。在您使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件；<o:p
        ></o:p>
      </p>
      <p>
        2）Bloom未行使或执行本协议任何权利或规定，不构成对前述权利或权利之放弃；<o:p
        ></o:p>
      </p>
      <p>
        3）倘本协议之任何规定因与中华人民共和国法律抵触而无效，您依然同意应依照法律，努力使该规定所反映之当事人意向具备效力，且本协议其它规定仍应具有完整的效力及效果；<o:p
        ></o:p>
      </p>
      <p>4）本协议之标题仅供方便而设，不具任何法律或契约效果；<o:p></o:p></p>
      <p>5）Bloom对本协议享有最终解释权。<o:p></o:p></p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b>2</b><b>2</b><b>、适用法律和争议解决</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        <b><u>本协议订立、履行、解释及争议解决均在</u></b
        ><b><u>Bloom</u></b
        ><b
          ><u
            >平台规则基础上理解，并适用中华人民共和国（为本条款之目的，不包括香港、澳门、台湾地区）法律</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>
        <b
          ><u
            >凡因履行本协议所产生的或与本协议有关的任何争议，双方首先应通过友好协商解决；如协商不成的，任何一方均应就争议向深圳市绽放芯知科技有限公司所在地有管辖权的法院提起诉讼。败诉方应赔偿胜诉方因该等诉讼产生的诉讼费、财产保全费、律师费、执行费、评估费、公告费等各项支出</u
          ></b
        >。<o:p></o:p>
      </p>`

const newPrivateInfo = `<div class="h2">Bloom 平台隐私政策</div>
      <p class="text">引言</p>
      <p>
        欢迎您使用我们的产品和服务！Bloom平台（指BloomAPP、<a style="color: #296bff"
          href="http://www.webloom.cn"
          ><u>www.webloom.cn</u></a
        >网页端等客户端，下称“Bloom平台”）运营者深圳市绽放芯知科技有限公司及其关联公司（以下简称“我们”）非常重视您的个人信息，并让您对个人信息拥有控制权，我们会使用强大的加密技术来保护您的隐私，同时制定严格的政策来管理所有数据。当您访问Bloom平台时，或使用我们提供的服务前，您需要同意本政策中关于我们如何收集、使用、储存和分享您的相关信息的规定。如果您不同意本隐私政策中的任何内容，请立即停止使用或访问我们的产品和服务。本隐私权政策旨在协助您了解我们会收集哪些信息、为什么收集这些信息，以及您如何更新、管理、导出和删除自己的信息。若您对本政策有任何问题，请联系我们。<o:p
        ></o:p>
      </p>
      <p>术语<o:p></o:p></p>
      <p>
        Cookie：Cookie
        是包含字符串的小文件，会在您访问网站时发送到您的计算机上。当您再次访问网站时，Cookie
        使该网站可以识别您的浏览器。<o:p></o:p>
      </p>
      <p>
        Cookie 还能存储用户使用偏好及其他信息。您可以重置您的浏览器拒绝所有的
        Cookie，或者在发送 Cookie 时提示。但如果没有
        Cookie，某些网站功能或服务可能无法正常工作。<o:p></o:p>
      </p>
      <p>
        应用数据缓存：应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。<o:p
        ></o:p>
      </p>
      <p>
        个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<o:p
        ></o:p>
      </p>
      <p>
        个人敏感信息：指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息等的个人信息（我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识）。<o:p
        ></o:p>
      </p>
      <p>儿童：指不满十四周岁的未成年人。<o:p></o:p></p>
      <p>
        IP地址：每台连接到互联网的计算机都指定了唯一的编号，称为互联网协议 (IP)
        地址。由于这些编号通常都是根据国家/地区的区域指定的，因此 IP
        地址通常可用于识别计算机连接至互联网时所在的国家/地区。<o:p></o:p>
      </p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>本政策将帮助您了解以下内容：<o:p></o:p></p>
      <p>一、我们如何搜集和使用您的信息<o:p></o:p></p>
      <p>二、我们如何使用Cookies<o:p></o:p></p>
      <p>三、我们如何共享、转让、公开披露您的信息<o:p></o:p></p>
      <p>四、您如何管理您的信息<o:p></o:p></p>
      <p>五、我们如何保护您的个人信息<o:p></o:p></p>
      <p>六、我们如何存储您的信息<o:p></o:p></p>
      <p>七、我们如何处理未成年人提供的个人信息<o:p></o:p></p>
      <p>八、本政策的更新<o:p></o:p></p>
      <p>九、适用范围<o:p></o:p></p>
      <p>十、如何联系我们<o:p></o:p></p>
      <p>
        <b>一. 我们如何搜集和使用您的信息？</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>1. 我们如何搜集您的信息？<o:p></o:p></p>
      <p>我们提供服务时，可能会收集、储存和使用下列信息：<o:p></o:p></p>
      <p>1.1 您提供的信息<o:p></o:p></p>
      <p>
        1.1.1
        您在注册帐号或使用我们的服务时，向我们提供的相关个人信息，例如您的姓名、电子邮件地址、电话号码、住址、<b
          >身份证</b
        ><b>及其他身份证件</b
        ><b>号码</b
        >等信息。如果您想充分使用我们提供的各种分享功能，可能还需要创建公开显示的个人资料，其中可能会包含您的姓名和照片。<o:p
        ></o:p>
      </p>
      <p>
        1.1.2
        您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时上传、提交、存储、发送或接收的信息。<o:p
        ></o:p>
      </p>
      <p>1.2 您在使用服务过程中，我们获取的信息<o:p></o:p></p>
      <p>
        我们会收集您使用的服务以及使用方式的信息，如您何时在Bloom平台观看了视频，何时访问了我们的广告服务，或何时查看了我们的广告和内容。此类信息包括：<o:p
        ></o:p>
      </p>
      <p>
        1.2.1
        设备信息：我们会收集设备专用的信息，例如您的硬件型号、操作系统信息、移动设备版本、设备识别码、屏幕分表率、网络环境等信息。<o:p
        ></o:p>
      </p>
      <p>1.2.2 日志信息<o:p></o:p></p>
      <p>
        · A.
        设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；<o:p
        ></o:p>
      </p>
      <p>
        · B.
        在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；<o:p
        ></o:p>
      </p>
      <p>1.2.3 IP地址<o:p></o:p></p>
      <p>
        · A.
        有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；<o:p
        ></o:p>
      </p>
      <p>
        · B.
        您通过我们的服务进行通讯的信息，例如曾通讯的帐号，以及通讯时间、数据和时长；<o:p
        ></o:p>
      </p>
      <p>
        · C.
        您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。<o:p
        ></o:p>
      </p>
      <p>
        1.2.4 设备中的视频、图片、游戏软件等
        为了给您提供全方位的服务体验，经过您的授权，我们的服务器会提取您设备中的视频、图片、软件名、版本号等，并通过加密上传到服务器进行比对，用于匹配与该视频、图片、软件相对应的显示功能。<o:p
        ></o:p>
      </p>
      <p>
        1.2.5 摄像头
        除本协议另有约定外，您设备上的摄像功能是保证您能多角度观看运动效果必备工具，如您禁用摄像功能，可能无法使用我们的部分产品或服务，或在使用过程中达不到最佳效果或使用受到限制。我们不会利用摄像头采集您的个人照片，除非经您授权或您自行上传、提交、发布，我们不会主动采集您设备中的图片、视频信息。<o:p
        ></o:p>
      </p>
      <p>
        1.2.6<b>位置信息</b>您可以授权开启设备定位功能并使用我们基于位置提供的相关服务，当然，您也可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。<o:p
        ></o:p>
      </p>
      <p>2. 我们如何使用您的信息<o:p></o:p></p>
      <p>我们可能将上述收集的信息用作以下用途：<o:p></o:p></p>
      <p>2.1 向您提供服务；<o:p></o:p></p>
      <p>
        2.2
        在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；<o:p
        ></o:p>
      </p>
      <p>2.3 帮助我们设计新服务，改善我们现有服务；<o:p></o:p></p>
      <p>
        2.4
        使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；<o:p
        ></o:p>
      </p>
      <p>2.5 向您提供与您更加相关的广告以替代普遍投放的广告；<o:p></o:p></p>
      <p>
        2.6 评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；<o:p
        ></o:p>
      </p>
      <p>2.7 执行软件验证、升级服务；<o:p></o:p></p>
      <p>
        2.8
        应用户特殊要求而提供特定服务时，需要将信息提供给我们的关联公司、第三方或其他用户；<o:p
        ></o:p>
      </p>
      <p>
        2.9
        其他有利于用户和Bloom平台运营者利益且不违反任何强制性法律法规的情况。<o:p
        ></o:p>
      </p>
      <p>2.10 让您参与有关我们产品和服务的调查<o:p></o:p></p>
      <p>
        3. 除非经过您的同意，否则我们不会向任何人提供您的个人敏感信息。<o:p
        ></o:p>
      </p>
      <p>
        <b>二.</b><b>我们如何使用Cookie</b><b>s</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储Cookie、Flash
        Cookie，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称“Cookies”）。借助于
        Cookies，网站能够存储您的偏好或购物车内的商品等数据。<o:p></o:p>
      </p>
      <p>
        如果您的浏览器或浏览器附加服务允许，您可修改对Cookie的接受程度或拒绝我们的Cookie。但如果您这么做，在某些情况下可能会影响您安全访问我们的网站，且可能需要在每一次访问我们的网站时更改用户设置。<o:p
        ></o:p>
      </p>
      <p>
        <b>三.</b><b></b><b>我们如何共享、转让、公开披露您的信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>1.共享<o:p></o:p></p>
      <p>
        我们不会与Bloom平台服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：<o:p
        ></o:p>
      </p>
      <p>
        （1）在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。<o:p
        ></o:p>
      </p>
      <p>
        （2）在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。<o:p
        ></o:p>
      </p>
      <p>
        （3）为您提供您需要的产品或服务必要的情况下共享：您通过Bloom平台购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易、配送及售后服务需求。<o:p
        ></o:p>
      </p>
      <p>
        （4）与关联公司间共享：为便于我们基于Bloom平台账户向您提供产品和服务，推荐您可能感兴趣的信息，识别会员账户异常，保护Bloom平台关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。<o:p
        ></o:p>
      </p>
      <p>
        （5）与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何目的。<o:p
        ></o:p>
      </p>
      <p>2.转让<o:p></o:p></p>
      <p>
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<o:p
        ></o:p>
      </p>
      <p>
        （1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<o:p
        ></o:p>
      </p>
      <p>
        （2）在Bloom平台服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私权政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。<o:p
        ></o:p>
      </p>
      <p>3.公开披露<o:p></o:p></p>
      <p>我们仅会在以下情况下，公开披露您的个人信息：<o:p></o:p></p>
      <p>
        （1）获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；<o:p
        ></o:p>
      </p>
      <p>
        （2）如果我们确定您出现违反法律法规或严重违反Bloom平台相关协议及规则的情况，或为保护Bloom平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及Bloom平台已对您采取的措施。<o:p
        ></o:p>
      </p>
      <p>4.共享、转让、公开披露个人信息时事先征得授权同意的例外<o:p></o:p></p>
      <p>
        <b
          ><u
            >根据相关法律法规规定，以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b><u>（</u></b
        ><b><u>1）</u></b
        ><b><u>与我们履行法律法规规定的义务相关的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b><u>（</u></b
        ><b><u>2）</u></b
        ><b><u>与国家安全、国防安全直接相关的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b><u>（</u></b
        ><b><u>3）</u></b
        ><b><u>与公共安全、公共卫生、重大公共利益直接相关的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b><u>（</u></b
        ><b><u>4）</u></b
        ><b><u>与刑事侦查、起诉、审判和判决执行等直接相关的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b><u>（</u></b
        ><b><u>5）</u></b
        ><b
          ><u
            >出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b><u>（</u></b
        ><b><u>6）</u></b
        ><b><u>您自行向社会公众公开的个人信息；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b><u>（</u></b
        ><b><u>7）</u></b
        ><b><u>您签订和履行合同所必需的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b
          ><u
            >（8）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        请知悉，根据适用的法律，<b
          ><u
            >若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>
        <b>四.</b><b></b><b>您如何管理您的信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>1.查询、更正和补充您的信息<o:p></o:p></p>
      <p>
        您有权查询、更正或补充您的信息。您可以通过登录Bloom平台，进入“我的-设置“对个人资料等信息进行查询、更正或补充。<o:p
        ></o:p>
      </p>
      <p>2.删除您的信息<o:p></o:p></p>
      <p>
        在以下情形中，您可以通过与Bloom平台客服联系向我们提出删除个人信息的请求：<o:p
        ></o:p>
      </p>
      <p>（1）如果我们处理个人信息的行为违反法律法规；<o:p></o:p></p>
      <p>
        （2）如果我们收集、使用您的个人信息，却未征得您的明确同意；<o:p></o:p>
      </p>
      <p>（3）如果我们处理个人信息的行为严重违反了与您的约定；<o:p></o:p></p>
      <p>（4）如果您主动注销了账户。<o:p></o:p></p>
      <p>
        若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。<o:p
        ></o:p>
      </p>
      <p>
        <b
          >当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以清除或实现匿名化。</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>3.改变您授权同意的范围<o:p></o:p></p>
      <p>
        您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。<o:p
        ></o:p>
      </p>
      <p>
        当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响我们此前基于您的授权而开展的个人信息处理。<o:p
        ></o:p>
      </p>
      <p>您有拒绝接收我们基于您的个人信息推送给您的商业广告。<o:p></o:p></p>
      <p>4.注销您的账户<o:p></o:p></p>
      <p>您可以通过以下方式申请注销您的账户：<o:p></o:p></p>
      <p>【登录Bloom平台联系客服，申请注销您的账号】<o:p></o:p></p>
      <p>
        在您主动注销账户之后，我们将停止为您提供产品或服务，并根据适用法律的要求删除您的个人信息，或对其进行匿名化处理。因法律法规规定需要留存个人信息的，我们将不会再次将其用于日常业务活动中。<o:p
        ></o:p>
      </p>
      <p>5.个人信息主体获取个人信息副本<o:p></o:p></p>
      <p>
        根据您的请求，我们会为您提供获取以下类型个人信息副本的方法，或在技术可行的前提下直接将以下个人信息的副本传输给第三方：<o:p
        ></o:p>
      </p>
      <p>1、个人基本资料、个人身份信息；<o:p></o:p></p>
      <p>2、个人健康生理信息、个人教育工作信息。<o:p></o:p></p>
      <p>6.响应您的上述请求<o:p></o:p></p>
      <p>
        （1）<b
          ><u
            >为保障您的账户安全，您向我们提出上述请求时，我们可能会先要求您验证自己的身份（如要求您提供书面请求或其他方式），然后再处理您的请求。</u
          ></b
        >
        <o:p></o:p>
      </p>
      <p>
        （2）对于您向我们提出的上述请求，我们将在15天内做出答复。如您不满意我们的答复，还可以通过Bloom平台客服进行投诉。<o:p
        ></o:p>
      </p>
      <p>
        （3）对于您合理的请求，我们原则上不收取费用，<b
          ><u
            >但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。</u
          ></b
        >
        <o:p></o:p>
      </p>
      <p>
        （4）<b
          ><u>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <!--[if-->a)&nbsp;
        <!--[endif]--><b><u>与我们履行法律法规规定的义务相关的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <!--[if-->b)&nbsp;
        <!--[endif]--><b><u>与国家安全、国防安全直接相关的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <!--[if-->c)&nbsp;
        <!--[endif]--><b
          ><u>与公共安全、公共卫生、重大公共利益直接相关的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <!--[if-->d)&nbsp;
        <!--[endif]--><b
          ><u>与刑事犯罪侦查、起诉、审判和执行判决等直接相关的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <!--[if-->e)&nbsp;
        <!--[endif]--><b
          ><u>有充分证据表明个人信息主体存在主观恶意或滥用权利的；</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <!--[if-->f)&nbsp;
        <!--[endif]--><b
          ><u
            >出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <!--[if-->g)&nbsp;
        <!--[endif]--><b><u></u></b
        ><b
          ><u
            >响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <!--[if-->h)&nbsp;
        <!--[endif]--><b><u>涉及商业秘密的。</u></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b>
          <o:p>&nbsp;</o:p>
        </b>
      </p>
      <p>
        <b>五</b><b>. 我们如何保护您的个人信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        1.
        所有Bloom产品都内置了强大的安全功能，并且我们制定了严格的信息管理政策，配备专业的技术团队，采取了一系列合理的预防措施，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失，其中包括：<o:p
        ></o:p>
      </p>
      <p>（1）使用加密技术来确保您的数据在传输过程中保持私密性；<o:p></o:p></p>
      <p>（2）提供多种安全功能来协助您保护自己的帐号安全；<o:p></o:p></p>
      <p>
        （3）审查我们在收集、存储和处理信息方面的做法（包括实体安全措施），以防未经授权的人员访问我们的系统；<o:p
        ></o:p>
      </p>
      <p>
        （4）所有因提供服务而必须接触个人信息的Bloom员工、承包商和代理商等，都需要遵守合同中规定的严格保密义务，否则可将被处分或被解约。<o:p
        ></o:p>
      </p>
      <p>
        2.互联网坏境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将根据法律规定承担相应责任。<o:p
        ></o:p>
      </p>
      <p>
        3.在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。<o:p
        ></o:p>
      </p>
      <p>
        <b>六</b><b>.</b><b>我们如何存储您的信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>1.存储地点<o:p></o:p></p>
      <p>
        原则上，我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。<o:p
        ></o:p>
      </p>
      <p>
        由于我们维护着遍布世界各地的服务器，因此，我们处理您的信息时所用的服务器可能并不是位于您所在的国家或地区。数据保护法律因国家或地区而异，不同国家或地区的数据保护力度也是有强有弱。无论是在哪里处理您的信息，我们都会一律采用本政策中所述的保护措施。另外，我们还会遵守某些与数据传输有关的法律框架，例如“EU-US
        Privacy Shield Frameworks”和“Swiss-US Privacy Shield Frameworks”。<o:p
        ></o:p>
      </p>
      <p>
        在以下情形下，我们会在履行了法律规定的义务后，向境外实体提供您的个人信息：<o:p
        ></o:p>
      </p>
      <p>（1）适用的法律有明确规定；<o:p></o:p></p>
      <p>（2）获得您的明确授权；或<o:p></o:p></p>
      <p>（3）您通过互联网进行跨境交易等个人主动行为。<o:p></o:p></p>
      <p>
        针对以上情形，我们会通过合同等形式确保以不低于本政策规定的程度保护您的个人信息。<o:p
        ></o:p>
      </p>
      <p>2.存储期限<o:p></o:p></p>
      <p>
        我们会采取合理可行的措施，尽力避免收集和处理无关的个人信息。<b
          ><u
            >我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求</u
          ></b
        >，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：<o:p
        ></o:p>
      </p>
      <p>
        （1）完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；<o:p
        ></o:p>
      </p>
      <p>（2）保证我们为您提供服务的安全和质量；<o:p></o:p></p>
      <p>（3）您是否同意更长的留存期间；<o:p></o:p></p>
      <p>（4）是否存在保留期限的其他特别约定。<o:p></o:p></p>
      <p>
        在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。<o:p
        ></o:p>
      </p>
      <p>
        <b>七.</b><b>我们如何处理未成年人提供的个人信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        1.
        我们非常重视未成年人信息的保护。我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。<o:p
        ></o:p>
      </p>
      <p>
        <b><u>2.</u></b
        ><b
          ><u
            >如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私权政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息；</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b><u>3.</u></b
        ><b><u>如果您是</u></b
        ><b
          ><u
            >14周岁以下儿童的，在您使用我们的服务前，您和您的父母或其他监护人应仔细阅读我们专门制定的《</u
          ></b
        ><b><u>Bloom平台儿童个人信息隐私权政策</u></b
        ><b><u>》，在确保已取得父母或其他监护人对《</u></b
        ><b><u>Bloom平台儿童个人信息隐私权政策</u></b
        ><b
          ><u
            >》的同意后，您才可在父母或其他监护人的指导下使用我们的服务，确保您在使用我们的服务和进行交易时的安全。</u
          ></b
        ><b
          ><u
            >若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务的。</u
          ></b
        >如您对您所监护的儿童的个人信息有疑问，请通过第十条中的联系方式与我们联系。<o:p
        ></o:p>
      </p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b>八</b><b>.本政策的更新</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        1.
        我们可能会不定期修改、更新本隐私政策，有关隐私政策的更新，我们会在Bloom平台中以通知公告等形式发布，您可以访问Bloom平台查询最新版本的隐私政策。对于重大变更，我们会向您发出郑重通知（包括对于某些服务，我们会通过电子邮件发送通知，说明对隐私政策进行的更改）。<o:p
        ></o:p>
      </p>
      <p>2.本政策所指的重大变更包括但不限于：<o:p></o:p></p>
      <p>
        （1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<o:p
        ></o:p>
      </p>
      <p>
        （2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<o:p
        ></o:p>
      </p>
      <p>（3）个人信息共享、转让或公开披露的主要对象发生变化；<o:p></o:p></p>
      <p>
        （4）您参与个人信息处理方面的权利及其行使方式发生重大变化；<o:p></o:p>
      </p>
      <p>
        （5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<o:p
        ></o:p>
      </p>
      <p>（6）个人信息安全影响评估报告表明存在高风险时。<o:p></o:p></p>
      <p>我们还会将本政策的旧版本存档，供您查阅。<o:p></o:p></p>
      <p>
        <b>九</b><b>. 适用范围</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        1.
        我们的隐私政策适用于由深圳市绽放芯知科技有限公司及其关联公司提供的所有服务，包括Bloom平台提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。<o:p
        ></o:p>
      </p>
      <p>
        2.除本政策说明的相关信息收集使用活动外，为方便您的访问并丰富您的体验，可能会有第三方提供的产品或服务（例如在Bloom平台上由第三方提供的产品和服务，以及在我们的服务中链接到的其他网站）。您可以选择是否访问这类内容或链接，或是否使用该第三方的产品或服务。但我们的隐私权政策不适用于第三方提供的产品和服务，对于第三方提供的产品或服务没有控制权。我们无法控制第三方掌握的您的任何个人信息。您在使用第三方产品或服务过程中的信息保护问题，不适用于本政策的管理。本政策也不适用于您自行选择提供给第三方的任何信息。请您查看该第三方的隐私保护政策。<o:p
        ></o:p>
      </p>
      <p>
        3.
        对于为我们的服务进行广告宣传，以及可能使用我们的cookies或其他日志信息来投放和使用广告的其他公司和组织，我们的隐私权政策并未涵盖其信息处理政策。<o:p
        ></o:p>
      </p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b>十、联系方式</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        您可以通过以下方式与我们联系，我们将在15天内回复您的请求：<o:p></o:p>
      </p>
      <p>
        1、如您对本政策内容有任何疑问、意见或建议，您可通过Bloom平台客服与我们联系；<o:p
        ></o:p>
      </p>
      <p>
        2、如您发现个人信息可能被泄露，您可以通过Bloom平台客服投诉举报；<o:p
        ></o:p>
      </p>
      <p>3、我们还设立了个人信息保护专职部门，您可以通过【bloom@sktedu.com】与其联系，办公地址：【深圳市南山区桃源街道平山社区留仙大道1005号众冠时代广场】。需注意的是，我们可能不会回复与本政策或与个人信息保护无关的问题。<o:p
    ></o:p>
      </p>
      <p>
        <b
          >如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，如协商不成的，任何一方均应就争议向深圳市绽放芯知科技有限公司所在地有管辖权的法院提起诉讼。败诉方应赔偿胜诉方因该等诉讼产生的诉讼费、财产保全费、律师费、执行费、评估费、公告费等各项支出。</b
        ><b>
          <o:p></o:p>
        </b>
      </p>`

const childrenProfile = `<div class="h2">Bloom 平台儿童用户服务协议</div>
      <p>尊敬的用户：<o:p></o:p></p>
      <p>
        非常感谢您注册成为Bloom平台（定义见下文）用户，为让您更好地使用Bloom平台及Bloom平台第三方服务商提供的产品和服务，请您及您的监护人务必审慎阅读、充分理解《Bloom平台用户协议》（以下称“用户协议”或“本协议”）各条款内容，<b
          ><u
            >特别是免除或者限制责任、争议解决和法律适用的条款，并选择接受或不接受，其中免除或限制责任的条款将以加粗字体及下划线显示，您</u
          ></b
        ><b><u>及您的监护人</u></b
        ><b><u>应重点阅读。</u></b>
        <o:p></o:p>
      </p>
      <p>
        除非您及您的监护人已阅读并接受本协议所有条款，否则您无权下载、安装或使用Bloom平台及Bloom平台第三方服务商提供相关产品和服务。<b
          ><u
            >您经您的监护人许可后按照注册页面提示填写信息、阅读并点击同意本协议且完成全部注册程序后，即表示您及您的监护人已充分阅读、理解并接受本协议的全部内容，并与我们达成一致，成为</u
          ></b
        ><b><u>Bloom平台的“用户”</u></b
        ><b><u>。如您和</u></b
        ><b><u>/或您的监护人不同意本协议和《</u></b
        ><b><u>儿童个人信息隐私政策</u></b
        ><b
          ><u>》的任何内容，可选择拒绝/不同意，并立即停止使用我们的服务。</u></b
        >
        <o:p></o:p>
      </p>
      <p>
        本协议为在《Bloom平台用户协议》基础上制定的特别协议，与《Bloom平台用户协议》如有不一致之处，以本协议为准；本政策未载明之处，以《Bloom平台用户协议》为准。<o:p
        ></o:p>
      </p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b>一、定义</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>1.1 儿童：指不满14周岁的未成年人。<o:p></o:p></p>
      <p>
        1.2 儿童个人信息：指不满14周岁的未成年人的包括但不限于<b
          ><u>姓名、身份证件信息、电话、住址、支付银行卡、登录IP等</u></b
        ><b
          ><u
            >以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种</u
          ></b
        ><b><u>信息</u></b
        >。<o:p></o:p>
      </p>
      <p>
        1.3监护人：指代理被监护人实施民事法律行为，保护被监护人的人身权利、财产权利以及其他合法权益等的人。<o:p
        ></o:p>
      </p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b>二、儿童用户行为规范</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        2.1<b
          ><u
            >您及监护人充分了解并同意，您的监护人必须为您账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。</u
          ></b
        >
        <o:p></o:p>
      </p>
      <p>
        2.2<b
          ><u
            >您及您的监护人同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为</u
          ></b
        >∶<o:p></o:p>
      </p>
      <p>1）发布或以其它方式传送含有下列内容之一的信息：<o:p></o:p></p>
      <p>·反对宪法所确定的基本原则的；<o:p></o:p></p>
      <p>
        ·危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<o:p></o:p>
      </p>
      <p>·损害国家荣誉和利益的；<o:p></o:p></p>
      <p>·煽动民族仇恨、民族歧视、破坏民族团结的；<o:p></o:p></p>
      <p>·破坏国家宗教政策，宣扬邪教和封建迷信的；<o:p></o:p></p>
      <p>·散布谣言，扰乱社会秩序，破坏社会稳定的；<o:p></o:p></p>
      <p>·散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<o:p></o:p></p>
      <p>·侮辱或者诽谤他人，侵害他人合法权利的；<o:p></o:p></p>
      <p>
        ·含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；<o:p
        ></o:p>
      </p>
      <p>
        ·含有中国法律、法规、规章、规范性文件等所限制或禁止的其它内容的；<o:p
        ></o:p>
      </p>
      <p>·含有Bloom认为不适合在Bloom展示的内容；<o:p></o:p></p>
      <p>2）以任何方式危害他人的合法权益；<o:p></o:p></p>
      <p>
        3）冒充其他任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；<o:p
        ></o:p>
      </p>
      <p>
        4）将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以发布、发送电子邮件或以其它方式传送；<o:p
        ></o:p>
      </p>
      <p>
        5）将侵害他人著作权、专利权、商标权、商业秘密、或其它专属权利（以下简称“专属权利”）之内容加以发布或以其它方式传送；<o:p
        ></o:p>
      </p>
      <p>
        6）将任何广告信函、促销资料、“垃圾邮件”、“滥发信件”、“连锁信件”、“直销”或其它任何形式的劝诱资料加以发布、发送或以其它方式传送；<o:p
        ></o:p>
      </p>
      <p>
        7）将设计目的在于干扰、破坏或限制任何计算机软件、硬件或通讯设备功能之计算机病毒（包括但不限于木马程序（trojanhorses）、蠕虫（worms）、定时炸弹、删除蝇（cancelbots）（以下简称“病毒”）或其它计算机代码、档案和程序之任何资料，加以发布、发送或以其它方式传送；<o:p
        ></o:p>
      </p>
      <p>
        8）干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；<o:p
        ></o:p>
      </p>
      <p>9）跟踪、人肉搜索或以其它方式骚扰他人；<o:p></o:p></p>
      <p>
        10）故意或非故意地违反任何适用的当地、国家法律，以及任何具有法律效力的规则；<o:p
        ></o:p>
      </p>
      <p>
        11）未经合法授权而截获、篡改、收集、储存或删除他人个人信息、站内邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的。<o:p
        ></o:p>
      </p>
      <p>
        2.3您已认可Bloom未对用户的使用行为进行全面控制，您使用任何内容时，包括依赖前述内容之正确性、完整性或实用性时，您同意将自行加以判断并承担所有风险，而不依赖于Bloom。但Bloom依其自行之考虑，拒绝和删除可经由本服务提供之违反本条款的或其它引起Bloom反感的任何内容。<b
          ><u
            >您了解并同意，Bloom依据法律法规的要求，或基于诚信为了以下目的或在合理必要范围内，认定必须将内容加以保存或揭露时，得加以保存或揭露</u
          ></b
        >：<o:p></o:p>
      </p>
      <p>a）遵守法律程序；<o:p></o:p></p>
      <p>b）执行本协议；<o:p></o:p></p>
      <p>c）回应任何第三人提出的权利主张；<o:p></o:p></p>
      <p>d）保护Bloom、其用户及公众之权利、财产或个人安全；<o:p></o:p></p>
      <p>e）其它Bloom认为有必要的情况。<o:p></o:p></p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b>三、监护责任</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        3.1<b
          ><u
            >监护人应当正确履行监护职责，教育引导儿童增强个人信息保护意识和能力，保护儿童个人信息安全</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>
        3.2<b
          ><u
            >监护人应当审慎保管个人银行卡、网银、微信、支付宝等支付方式的支付密码，并为单笔消费和单日消费设置合理限额，确保儿童在未经监护人许可的情况下无法自行完成消费或大额消费</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>
        3.3<b
          ><u
            >监护人应教育引导儿童规范使用产品过程中的语言、文字及行为，违反法律法规及</u
          ></b
        ><b><u>Bloom平台</u></b
        ><b><u>规则、公告给我们和他人造成的损失，由监护人承担相应法律责任</u></b
        >。<o:p></o:p>
      </p>
      <p>
        3.4您在使用本服务过程中应当遵守相关的法律法规，并尊重社会公德和善良风俗。如果您的行为违反了前述内容，您的监护人应当为此承担责任。<o:p
        ></o:p>
      </p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b>四、儿童用户隐私制度</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        4.1保护用户个人信息是Bloom的一项基本原则。Bloom将按照本协议及《儿童个人信息隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息的保护规定与《儿童个人信息隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《儿童个人信息隐私政策》的内容为准。<o:p
        ></o:p>
      </p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b>五、法律适用和争议解决</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        5.1<b
          ><u
            >本协议订立、履行、解释及争议解决均在Bloom平台规则基础上理解，并适用中华人民共和国（为本协议之目的，不包括香港、澳门、台湾地区）法律</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>
        5.2<b
          ><u
            >凡因履行本协议所产生的或与本协议有关的任何争议，双方首先应通过友好协商解决；如协商不成的，任何一方均应就争议向深圳市绽放芯知科技有限公司所在地有管辖权的法院提起诉讼。败诉方应赔偿胜诉方因该等诉讼产生的诉讼费、财产保全费、律师费、执行费、评估费、公告费等各项支出</u
          ></b
        >。<o:p></o:p>
      </p>`

const childrenPrivateInfo = `<div class="h2">Bloom 平台儿童个人信息隐私权政策</div>
      <p class="text">引言</p>
      <p>
        欢迎您使用我们的产品和服务！Bloom平台（指Bloom
        APP、www.webloom.cn网页端等客户端，下称“Bloom平台”）运营者深圳市绽放芯知科技有限公司及其关联公司（或简称“我们”）深知保护儿童（指未满十四周岁的未成年人，下同）个人信息安全和隐私的重要性。在《Bloom平台隐私政策》的基础上，我们希望通过《Bloom平台儿童个人信息隐私权政策》（以下简称“本政策”）说明我们在收集和使用儿童个人信息时对应的处理规则等相关事宜。您作为您孩子的父母或其他监护人（以下统称为“监护人”），<b
          ><u>请在您或您的孩子使用Bloom平台的产品及服务（定义详见《</u></b
        ><b><u>Bloom平台隐私政策</u></b
        ><b
          ><u
            >》，以下统称“我们的产品及服务”）前务必仔细阅读并透彻理解本政策，特别是以粗体</u
          ></b
        ><b><u>/粗体下划线标识的条款应重点阅读，在确认充分理解</u></b
        ><b><u>并同意全部条款后再开始使用或允许您的孩子使用</u></b
        >。<o:p></o:p>
      </p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b>监护人特别说明：</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        <b
          ><u
            >您的理解和配合对我们保护您孩子的个人信息和隐私安全非常必要，为了维护您孩子的合法权益，我们希望您可以协助我们，确保您的孩子在您的同意和指导下使用我们的产品及服务和向我们提交个人信息。我们将根据本政策采取特殊措施保护我们获得的您孩子的个人信息。如果您不同意本政策的内容，请您要求您的孩子立即停止访问/使用我们的产品及服务。</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b
          ><u>
            <o:p>&nbsp;</o:p>
          </u></b
        >
      </p>
      <p><b>儿童特别说明</b>：<o:p></o:p></p>
      <p>
        <b
          ><u
            >任何儿童参加网上活动都应事先取得监护人的同意。如果您是儿童，请务必通知您的监护人共同阅读本政策，并在您使用我们的产品及服务、提交个人信息之前，寻求您的监护人的同意和指导。</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        <b
          ><u>
            <o:p>&nbsp;</o:p>
          </u></b
        >
      </p>
      <p>
        本政策适用于我们在中华人民共和国境内通过网络从事收集、存储、使用、转移、分享和披露儿童个人信息等活动。本政策为在《Bloom平台隐私政策》基础上制定的特别规则，与《Bloom平台隐私政策》如有不一致之处，以本政策为准；本政策未载明之处，则参照适用《Bloom平台隐私政策》。<o:p
        ></o:p>
      </p>
      <p>
        在您阅读完本政策后，如对本政策或与本政策相关的事宜有任何问题，可通过<b>本政策“七、如何联系我们”</b>章节所列的反馈渠道联系我们，我们会尽快为您作出解答。<o:p
        ></o:p>
      </p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>本政策将帮助您了解以下内容：<o:p></o:p></p>
      <p>一、我们如何收集和使用儿童个人信息<o:p></o:p></p>
      <p>二、我们如何共享、转让、公开披露儿童个人信息<o:p></o:p></p>
      <p>三、我们如何储存儿童个人信息<o:p></o:p></p>
      <p>四、我们如何保护儿童个人信息<o:p></o:p></p>
      <p>五、如何管理儿童个人信息<o:p></o:p></p>
      <p>六、本政策的修订<o:p></o:p></p>
      <p>七、如何联系我们<o:p></o:p></p>
      <p>
        <o:p>&nbsp;</o:p>
      </p>
      <p>
        <b><br /></b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        <!--[if-->一、&nbsp;
        <!--[endif]--><b>我们如何收集和使用儿童个人信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        （一）我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息。<b
          ><u
            >您在使用我们的产品或服务中主动向我们提供您孩子的个人信息，例如您在我们为您提供的评论、社区及其他信息发布功能中分享的您孩子的照片、视频或其他信息，表示您已经同意我们收集和按照本政策的内容使用您孩子的个人信息</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>
        （二）您或您的孩子在使用我们的产品及服务过程中，我们为向您或者您的孩子提供我们的产品及服务（如提供个性化展示或推荐以及为您的账户提供安全保障等）目的，我们可能还会收集和使用其他儿童个人信息，有关具体的使用目的、收集个人信息的范围以及拒绝提供相应信息的后果请您查阅《Bloom平台隐私政策》
        “<b>我们如何</b><b>搜</b
        ><b>集和使用您的个人信息</b>”章节进行详细了解。<o:p></o:p>
      </p>
      <p>
        此外，我们也许会通过Cookies自动收集您或您孩子的个人信息，具体请您查阅《Bloom平台隐私政策》
        “我们如何使用Cookies”部分进行详细了解。如我们需要超出上述范围收集和使用儿童个人信息，我们将再次征得监护人的同意。<o:p
        ></o:p>
      </p>
      <p>
        <b
          ><u
            >请您注意，绝大多数情形下我们无法识别且不会判断收集和处理的个人信息是否属于儿童个人信息，我们将按照《Bloom平台隐私政策》收集和处理用户的个人信息</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>（三）征得授权同意的例外<o:p></o:p></p>
      <p>
        根据相关法律法规规定，以下情形中收集儿童的信息无需征得儿童监护人的授权同意：<o:p
        ></o:p>
      </p>
      <p>1、与我们履行法律法规规定的义务相关的；<o:p></o:p></p>
      <p>
        2、与国家安全、国防安全、公共安全、公共卫生、重大公共利益有关的；<o:p
        ></o:p>
      </p>
      <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；<o:p></o:p></p>
      <p>
        4、出于维护儿童的生命、财产等重大合法权益但又很难得到监护人同意的；<o:p
        ></o:p>
      </p>
      <p>5、所收集的信息是儿童或监护人自行向社会公众公开的；<o:p></o:p></p>
      <p>
        6、从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；<o:p
        ></o:p>
      </p>
      <p>
        7、根据与您或您的孩子签订和履行相关协议或其他书面文件所必需的；<o:p
        ></o:p>
      </p>
      <p>
        8、
        用于维护我们的产品及服务的安全稳定运行所必需的，例如发现、处置我们的产品及服务的故障；<o:p
        ></o:p>
      </p>
      <p>
        9、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；<o:p
        ></o:p>
      </p>
      <p>10、法律法规规定的其他情形。<o:p></o:p></p>
      <p>
        <!--[if-->二、&nbsp;
        <!--[endif]--><b>我们如何共享、转让、公开披露儿童个人信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        我们承诺对儿童个人信息进行严格保密，仅在符合本政策说明和您明确授权同意的情况下对外共享儿童个人信息。<b
          ><u
            >为了提升信息处理效率，降低信息处理成本，或提高信息处理准确性，我们可能会委托有能力的我们的关联公司或其他专业机构代表我们来处理儿童个人信息，具体请参见《Bloom平台隐私政策》
            “我们如何共享、转让、公开披露您的信息”部分</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>
        <b
          ><u
            >除了《Bloom平台隐私政策》“我们如何共享、转让、公开披露您的信息”部分所述的内容外，对于儿童个人信息，我们还将会采取如下措施来保护儿童个人信息在共享、转让和公开披露过程中的安全：</u
          ></b
        ><b
          ><u>
            <o:p></o:p> </u
        ></b>
      </p>
      <p>
        1、如果为了本政策所述目的而需要将儿童个人信息共享至第三方，我们将评估该第三方收集儿童个人信息的合法性、正当性、必要性。<o:p
        ></o:p>
      </p>
      <p>
        2、我们将要求第三方对儿童个人信息采取保护措施，并且严格遵守相关法律法规与监管要求。我们会要求接收儿童个人信息的第三方遵守严格的保密义务及采取有效的保密措施，禁止其将这些儿童个人信息用于未经儿童及其监护人授权的用途，并要求受托公司依法履行以下义务：<o:p
        ></o:p>
      </p>
      <p>
        （1）按照法律、行政法规的规定和我们的要求处理儿童个人信息；<o:p></o:p>
      </p>
      <p>（2）协助我们回应儿童监护人提出的申请；<o:p></o:p></p>
      <p>
        （3）采取措施保障信息安全，并在发生儿童个人信息泄露安全事件时，及时向我们反馈；<o:p
        ></o:p>
      </p>
      <p>（4）委托关系解除时及时删除儿童个人信息；<o:p></o:p></p>
      <p>（5）不得转委托；<o:p></o:p></p>
      <p>（6）其他依法应当履行的儿童个人信息保护义务。<o:p></o:p></p>
      <p>
        3、另外，我们会按照法律法规的要求征得您的同意，或确认第三方已经征得您同意。<o:p
        ></o:p>
      </p>
      <p>
        <!--[if-->三、&nbsp;
        <!--[endif]--><b>我们如何储存儿童个人信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        （一）<b
          ><u
            >我们在中华人民共和国境内运营中收集和产生的儿童个人信息，将存储在中国境内</u
          ></b
        >。以下情形下，我们会在履行了法律规定的义务后，向境外的组织或个人提供儿童的个人信息：<o:p
        ></o:p>
      </p>
      <p>1、适用的法律有明确规定；<o:p></o:p></p>
      <p>2、获得您的明确授权；<o:p></o:p></p>
      <p>3、您或者您的孩子通过互联网进行跨境交易等个人主动行为。<o:p></o:p></p>
      <p>
        针对以上情形，我们会通过合同等形式确保以不低于本政策规定的程度保护儿童的个人信息。<o:p
        ></o:p>
      </p>
      <p>
        （二）我们会采取合理可行的措施，尽力避免收集和处理无关的儿童的个人信息。<b
          ><u
            >我们只会在达成本政策所述目的所需的期限内保留儿童的个人信息，除非法律有强制的留存要求</u
          ></b
        >。关于我们如何确定儿童个人信息存储期限请参见《Bloom平台隐私政策》“我们如何保护您的信息”。如我们终止服务或运营，我们将及时停止继续收集儿童个人信息的活动，同时会遵守相关法律法规要求提前向监护人通知，并在终止服务或运营后对儿童的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。<o:p
        ></o:p>
      </p>
      <p>
        <!--[if-->四、&nbsp;
        <!--[endif]--><b>我们如何保护儿童个人信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        我们非常重视儿童的隐私安全，并采取一切合理可行的措施，保护儿童个人信息：<o:p
        ></o:p>
      </p>
      <p>
        （一）<b><u>我们会严格控制儿童个人信息的访问权限</u></b
        >，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。<o:p
        ></o:p>
      </p>
      <p>
        （二）我们已制定儿童<b><u>个人信息安全事件应急预案</u></b
        >，我们会定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施等。我们将及时将事件相关情况以App推送通知、发送邮件/短消息等方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将承担相应的法律责任。<o:p
        ></o:p>
      </p>
      <p>
        （三）如您希望了解更多，请查阅《Bloom平台隐私政策》“<b
          >我们如何保护您的</b
        ><b>个人</b
        ><b>信息</b>”章节，详细了解我们如何采取了哪些措施保护儿童个人信息。<o:p
        ></o:p>
      </p>
      <p>
        <!--[if-->五、&nbsp;
        <!--[endif]--><b>如何管理儿童个人信息</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        （一）<b
          ><u
            >为了您或您的孩子在使用我们的产品及服务期间可以更加便捷地访问和管理您孩子的个人信息，同时保障注销账户的权利，我们在客户端中为您和您的孩子提供了相应的操作设置，您和您的孩子可以按照《Bloom平台隐私政策》中的“您如何管理您的信息”章节指引进行操作</u
          ></b
        >。<o:p></o:p>
      </p>
      <p>
        （二）下列情形下，您或您的孩子可以通过《Bloom平台隐私政策》“如何联系我们”所列的渠道联系我们，要求删除相应的儿童个人信息：<o:p
        ></o:p>
      </p>
      <p>
        1、我们违反法律、行政法规的规定或者双方的约定收集、存储、使用、对外提供儿童个人信息的；<o:p
        ></o:p>
      </p>
      <p>
        2、超出目的范围或者必要期限收集、存储、使用、对外提供儿童个人信息的；<o:p
        ></o:p>
      </p>
      <p>3、您撤回同意的；<o:p></o:p></p>
      <p>4、您或您的孩子通过注销等方式终止使用产品或者服务的。<o:p></o:p></p>
      <p>
        <!--[if-->六、&nbsp;
        <!--[endif]--><b>本政策的修订</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        我们可能会根据我们的产品及服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分，我们会在专门页面上展示最新修改版本。由于我们的用户较多，对于重大变更，我们还会提供更为显著的通知（包括通过网站或客户端首页公示的方式进行通知甚至向您提供弹窗提示），具体详见《Bloom平台隐私政策》第八条“本政策的更新”的规定。<o:p
        ></o:p>
      </p>
      <p>
        <!--[if-->七、&nbsp;
        <!--[endif]--><b>如何联系我们</b
        ><b>
          <o:p></o:p>
        </b>
      </p>
      <p>
        如您和您的孩子对本政策存在任何疑问，或对于儿童个人信息处理存在任何投诉、意见，请通过以下渠道联系我们，我们将在收到问题、意见或建议，<b
          ><u>并验证监护人和/或儿童身份后的十五天内回复您的请求</u></b
        >：<o:p></o:p>
      </p>
      <p>1、您可通过Bloom平台客服与我们联系；<o:p></o:p></p>
      <p>
        2、如发现个人信息可能被泄露，您可以通过Bloom平台客服投诉举报；<o:p
        ></o:p>
      </p>
      <p>
        3、您可以通过【bloom@sktedu.com】与我们的个人信息保护专职部门联系，办公地址：【深圳市南山区桃源街道平山社区留仙大道1005号
        众冠时代广场】。<o:p></o:p>
      </p>
      <p>
        需注意的是，我们可能不会回复与本政策或与个人信息保护无关的问题。<o:p
        ></o:p>
      </p>`

export default {
  privateInfo,
  profile,
  newProfile,
  newPrivateInfo,
  childrenProfile,
  childrenPrivateInfo
}



// WEBPACK FOOTER //
// ./src/assets/js/protocol-config.js